import { render } from "./relic.vue?vue&type=template&id=18a8e65b&scoped=true"
import script from "./relic.vue?vue&type=script&lang=js"
export * from "./relic.vue?vue&type=script&lang=js"

import "./relic.vue?vue&type=style&index=0&id=18a8e65b&lang=scss&scoped=true"

import exportComponent from "F:\\project\\2023\\山东博物馆大屏\\shandong\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a8e65b"]])

export default __exports__